import { render, staticRenderFns } from "./course-occupy.vue?vue&type=template&id=633eb2c9&"
import script from "./course-occupy.vue?vue&type=script&lang=ts&"
export * from "./course-occupy.vue?vue&type=script&lang=ts&"
import style0 from "./course-occupy.vue?vue&type=style&index=0&id=633eb2c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports